/* eslint-disable */
import { useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import openDatePicker from '../common/util/openDatePicker';
import moment from "moment";

import SelectField from "../common/components/SelectField";
import EditItemView from './components/EditItemView';
import EditAttributesAccordion from "./components/EditAttributesAccordion";
import { useTranslation } from "../common/components/LocalizationProvider";
import SettingsMenu from "./components/SettingsMenu";
import useSettingsStyles from "./common/useSettingsStyles";
import { useLocalization } from "../common/components/LocalizationProvider";

const CostPage = () => {
  const { classes } = useSettingsStyles();
  const { htmlLang } = useLocalization();
  const t = useTranslation();
  const theme = useTheme();

  const [item, setItem] = useState(null);
  const eventTimeRef = useRef(null);

  const validate = () =>
    item && item.name && item.type && item.eventTime && item.price;

  return (
    <EditItemView
      endpoint="costs"
      item={item}
      setItem={setItem}
      validate={validate}
      menu={<SettingsMenu />}
      breadcrumbs={["userAdmin", "sharedCosts", "sharedCost"]}
    >
      {item && (
        <>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" gap={1}>
                <NewReleasesIcon color="primary" />
                <Typography variant="subtitle1">
                  {t("sharedRequired")}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Box display="flex" flexDirection="column" gap={3}>
                {/* Primeira linha - Dispositivo e Nome */}
                <Box
                  display="flex"
                  gap={2}
                  sx={{ flexDirection: { xs: "column", sm: "row" } }}
                >
                  {/* Dispositivo */}
                  <Box flex={1} minWidth={0}>
                    <SelectField
                      fullWidth
                      value={item.deviceId}
                      emptyValue={null}
                      onChange={(event) =>
                        setItem({ ...item, deviceId: event.target.value })
                      }
                      endpoint="/api/devices"
                      label={t("sharedDevice")}
                    />
                  </Box>

                  {/* Nome do Custo */}
                  <Box flex={1} minWidth={0}>
                    <TextField
                      fullWidth
                      value={item.name || ""}
                      onChange={(event) =>
                        setItem({ ...item, name: event.target.value })
                      }
                      label={t("sharedName")}
                    />
                  </Box>

                  {/* Placeholder para manter 3 colunas */}
                  <Box flex={1} minWidth={0} />
                </Box>

                {/* Segunda linha - Categoria, Data e Preço */}
                <Box
                  display="flex"
                  gap={2}
                  sx={{ flexDirection: { xs: "column", sm: "row" } }}
                >
                  {/* Categoria */}
                  <Box flex={1} minWidth={0}>
                    <TextField
                      fullWidth
                      value={item.type || ""}
                      onChange={(event) =>
                        setItem({ ...item, type: event.target.value })
                      }
                      label={t("costCategory")}
                    />
                  </Box>

                  {/* Data */}
                  <Box flex={1} minWidth={0}>
                    <TextField
                      fullWidth
                      label={t("costDate")}
                      InputLabelProps={{ shrink: true }}
                      value={item.eventTime ? moment(item.eventTime).locale("en").format(moment.HTML5_FMT.DATE) : ""}
                      onChange={(event) =>
                        setItem({ ...item, eventTime: event.target.value })
                      }
                      InputProps={{
                        inputProps: { type: "date", lang: htmlLang },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton size="small" edge="end" onClick={() => openDatePicker(eventTimeRef.current)}>
                              <CalendarTodayIcon sx={{ color: theme.palette.action.active }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      inputRef={eventTimeRef}
                      className={classes.dateInput}
                    />
                  </Box>

                  {/* Preço */}
                  <Box flex={1} minWidth={0}>
                    <TextField
                      fullWidth
                      value={item.price || "0"}
                      onChange={(event) =>
                        setItem({ ...item, price: event.target.value })
                      }
                      label={t("sharedPrice")}
                      type="number"
                      inputProps={{ step: "0.01" }}
                    />
                  </Box>
                </Box>

                {/* Descrição (ocupando linha completa) */}
                <Box width="100%">
                  <TextField
                    fullWidth
                    value={item.description || ""}
                    onChange={(event) =>
                      setItem({ ...item, description: event.target.value })
                    }
                    label={t("sharedDescription")}
                    multiline
                    rows={3}
                    variant="outlined"
                  />
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
          <EditAttributesAccordion
            attributes={item.attributes}
            setAttributes={(attributes) => setItem({ ...item, attributes })}
            definitions={{}}
          />
        </>
      )}
    </EditItemView>
  );
};

export default CostPage;
